<template>
  <div>
    <el-card shadow="never" class="cbox">
      <el-tabs v-model="activeName" tab-position="left">
        <el-tab-pane v-for="(item, idx) in list" :key="idx" :label="item.label" :name="item.name">
          <card :title="item.label" :content="item.content" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'about',
      list: [{
        label: '关于我们',
        name: 'about',
        content: `<section id="nice" data-tool="mdnice编辑器" data-website="https://www.mdnice.com" style="color: black; line-height: 1.6; word-spacing: 0px; letter-spacing: 0px; word-break: break-word; word-wrap: break-word; text-align: left; font-family: Optima-Regular, Optima, PingFangSC-light, PingFangTC-light, 'PingFang SC', Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; font-size: 14px; padding: 10px;"><p data-tool="mdnice编辑器" style="padding-top: 8px; padding-bottom: 8px; margin: 0; line-height: 26px; color: black; font-size: 14px;">本网站一贯高度重视知识产权保护并遵守中华人民共和国各项知识产权法律、法规和具有约束力的规范性文件。本网站坚信著作权拥有者的合法权益应该得到尊重和依法保护。本网站坚决反对任何违反中华人民共和国有关著作权的法律法规的行为。由于我们无法对用户上传到本网站的所有信息进行充分的监测，我们制定了旨在保护知识产权权利人合法权益的措施和步骤，当著作权人和/或依法可以行使信息网络传播权的权利人（以下简称“权利人”）发现本网站上用户上传内容侵犯其信息网络传播权时，权利人应事先向本网站发出权利通知，本网站将根据相关法律规定采取措施删除相关内容。具体措施和步骤如下：
如果您是某一作品的著作权人和/或依法可以行使信息网络传播权的权利人，且您认为本网站站上用户上传内容侵犯了您对该等作品的信息网络传播权，请您务必书面通知本网站，您应对书面通知陈述之真实性负责。<br>
为方便本网站及时处理您之意见，您的通知书中应至少包含以下内容：<br>
您的名称（姓名）、联系方式及地址；<br>
要求删除的作品的名称和在本网站的地址；<br>
构成侵权地初步证明材料，谨此提示以下材料可能构成初步证明：<br>
对于涉嫌侵权作品拥有著作权或依法可以行使信息网络传播权的权属证明；<br>
对涉嫌侵权作品侵权事实的举证。<br>
您的签名。<br>
一旦收到符合上述要求之通知，我们采取包括删除等相应措施。如不符合上述条件，我们会请您提供相应信息，且暂不采取包括删除等相应措施。<br>
在本网站上载作品的用户视为同意本网站就前款情况所采用的相应措施。本网站不因此而承担任何违约责任或其他任何法律责任。本网站在收到上述通知后会发送电子邮件通知上载该等作品的用户。对于多次上载涉嫌侵权作品的用户，我们将取消其用户资格。<br></p>
</section>`
      }, /* {
        label: '联系我们',
        name: 'concat',
        content: `<section id="nice" data-tool="mdnice编辑器" data-website="https://www.mdnice.com" style="color: black; line-height: 1.6; word-spacing: 0px; letter-spacing: 0px; word-break: break-word; word-wrap: break-word; text-align: left; font-family: Optima-Regular, Optima, PingFangSC-light, PingFangTC-light, 'PingFang SC', Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; font-size: 14px; padding: 10px;"><p data-tool="mdnice编辑器" style="padding-top: 8px; padding-bottom: 8px; margin: 0; line-height: 26px; color: black; font-size: 14px;">联系邮箱：contact@99maiyou.cn&nbsp;<br>
公司地址：陕西省西安市雁塔区唐延路与科技路交汇处旺座国际城B座10层<br>
邮编：710000
</section>`
      },  */{
        label: '隐私政策',
        name: 'policy',
        content: `<section id="nice" data-tool="mdnice编辑器" data-website="https://www.mdnice.com" style="color: black; line-height: 1.6; word-spacing: 0px; letter-spacing: 0px; word-break: break-word; word-wrap: break-word; text-align: left; font-family: Optima-Regular, Optima, PingFangSC-light, PingFangTC-light, 'PingFang SC', Cambria, Cochin, Georgia, Times, 'Times New Roman', serif; font-size: 14px; padding: 10px;"><p data-tool="mdnice编辑器" style="padding-top: 8px; padding-bottom: 8px; margin: 0; line-height: 26px; color: black; font-size: 14px;">1、我们如何收集和使用您的个人信息<br>
2、我们如何使用 Cookie<br>
3、您的个人信息如何存储以及在全球范围转移<br>
4、我们如何共享、转让、公开披露您的个人信息<br>
5、我们如何保护您的个人信息<br>
6、您的权利<br>
1、我们如何收集和使用您的个人信息个人信息是指以 电子或者其他方式记录的能够单独或者与其他信息结合 识别特定自然人身份或者反映特定自然人活动情况的 各种信息。个人信息及个人敏感信息具体包含的内容参见 GB/T35273《个人信息安全规范》以及GB/T25069-2010 《信息安全技术 术语》在你使用“吾零网络”软件及服务的过程中，我们 将根据合法、正当、必要的原则，收集信息。我们收集 或请你提供的信息将用于：<br>
1.保障产品的基础正常运行；<br>
2.实现各项功能和服务；<br>
3.优化、改善产品和服务；<br>
4.保障产品、服务以及用户使用安全；<br>
5.遵循法律法规<br>
与国家标准的规定。（一）我们直接收集与使用的个人 信息我们会按照如下方式收集你在使用服务时主动提供的 ，以及通过自动化手段收集你在使用功能或接受服务过程 中产生的信息：<br>
1.保障“吾零网络”和服务的正常运行 当你使用“吾零网络”及相关服务时，为了保障软件与 服务的正常运行，我们会收集你的硬件型号、操作系统 版本号、国际移动设备识别码（IMEI ）、IP 地址、软件版本号、网络接入方式及类型、操作日志等信息 。请你了解，这些信息是我们提供服务和保障产品正常运行 所必须收集的基本信息。为了实现图片或视频的缓存和使用 降低流量消耗，我们会请求使用手机存储的权限，拒绝同意 该权限会使你无法实现上述功能，但不影响“吾零网络” 其他功能与服务的正常使用。"<br>
2.注册、认证、登录“吾零网络”和相关服务<br>
（1）当你注册、 登录“吾零网络”及相关服务时，你可以通过手机号创建账号 我们将通过发送短信验证码来验证你的身份是否有效，并且你 可完善相关的网络身份识别信息（如头像、昵称和密码）， 收集这些信息是为了帮助你完成注册。你还可根据自身需求 选择填写性别、生日、介绍等信息完善你的个人信息。<br>
（2）你也可以使用第三方账号（如微信、QQ、微博账号等） 登录进入吾零网络，你此时将授权我们获取你在第三方平台 注册的公开信息（头像、昵称等），并在你同意本隐私政策 后将你的第三方账号与你的吾零网络账户绑定，使你可以 通过第三方账号直接登录并使用本产品和相关服务。<br>
（3）在你使用发布内容等需进行身份认证的功能或服务时 根据中华人民共和国相关法律法规，你可能需要提供你的 真实身份信息（真实姓名、身份证号码、电话号码等） 以完成实名验证。如你不提供这些信息，你将不能使用相 关功能，但你可以继续使用“吾零网络”的其他服务。 这些信息属于个人敏感信息，我们将采用行业内通行的 方式及尽最大的商业努力来保护你个人敏感信息的安全 。如果你不提供这些信息，你将可能无法获得相关服务 ，但不影响“吾零网络”其他功能与服务的正常使用。<br>
3.为你推荐个性化的图文内容个性化推荐是“吾零网络” 核心的功能之一。为实现这一功能，我们可能会收集并使用 下列信息：<br>
（1）关注、搜索、浏览偏好（例如：你感兴趣 的文章）等你的操作、使用行为信息；<br>
（2）发布、点赞、 评论等你主动提供的信息；<br>
（3）注册时填写的性别、 生日等个人信息。<br>
（4）获得你的明示同意后的 WIFI 状态、电话状态、地理位置信息。拒绝提供地理位置信息 仅会使你无法使用上述功能，但不影响“吾零网络”其他 功能与服务的正常使用。我们可能会将上述信息与来自我们 其他服务的信息结合，进行综合统计并通过算法做特征与偏好分析 用以向你进行个性化推荐、展示或推送你可能感兴趣的特定内容 ，或者推送更合适你的特定功能或服务：<br>
（1）向你展示、 推荐或推送与你有更高相关程度的图文内容；<br>
（2）推荐与你相关 程度更高的程序化广告。请你了解，我们收集、使用上述信息时进 行了去标识化处理，数据分析仅对应特定的、无法直接关联 用户身份的编码，无法也绝不会与你的真实身份相关联。<br>
4.为你提供内容发布功能或服务你主动发布内容、评论时， 我们将收集相关内容信息，并展示你的昵称、头像等。<br>
（1）你发布图文内容时，我们会请求你授权相机、照片 、读取外部存储、等敏感权限。你如果拒绝授权提供，将无法 使用此功能，但不影响你正常使用吾零网络的其他功能。<br>
5.为你提供互动功能或服务<br>
（1）你主动关注你感兴趣的账号 并与其他账号进行互动，进行评论或分享内容时，我们会收集 你关注的账号，并向你展示你关注账号发布内容。<br>
（2）你使用 推荐通讯录好友功能时，在获得你的明示同意后，我们会将你 通讯录中的信息进行高强度加密算法处理后，用于向你推荐 通信录中的好友。通讯录信息属于个人敏感信息，拒绝提供 该信息仅会使你无法使用上述功能，但不影响你正常使用 “吾零网络”及相关服务的其他功能。<br>
6.为你提供搜索服务你使用吾零网络的搜索服务时，我们会 收集你的搜索关键字信息、日志<br>
</section>`
      }]
    }
  }
}
</script>

<style lang="scss">
.cbox {
  min-height: calc(100vh - 188px);
}  
</style>
